import { FC } from "react";

import { LOGO_DEFAULT_SIZE } from "components/constants";

export type ForumLogoIconProps = {
  className?: string;
  color?: string;
  width?: number;
};

const SVG_DEFAULT_HEIGHT = 18;
const SVG_DEFAULT_WIDTH = 68;

// Calculate the height to ensure we keep the desired aspect ratio given it's width
const calculateHeight = (width: number) => (width * SVG_DEFAULT_HEIGHT) / SVG_DEFAULT_WIDTH;

export const ForumLogoIcon: FC<ForumLogoIconProps> = ({
  className,
  color = "black",
  width = LOGO_DEFAULT_SIZE,
}) => (
  <svg
    className={className}
    height={calculateHeight(width)}
    viewBox={`0 0 ${SVG_DEFAULT_WIDTH} ${SVG_DEFAULT_HEIGHT}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.72852 2.2959H10.7121V3.43648H3.02196V8.33982H9.58326V9.45689H3.02196V16.0887H1.72852V2.2959Z"
      fill={color}
    />
    <path
      d="M25.6582 2.2959H31.808C34.3008 2.2959 35.7236 3.71869 35.7236 6.01162C35.7236 8.30454 34.9946 8.82192 33.4072 9.32754V9.38634C34.83 9.86844 35.3003 10.915 35.3944 13.055C35.4884 15.2774 35.7471 15.8301 35.9941 16.0064V16.0887H34.6065C34.3008 15.8771 34.2185 15.3597 34.1009 13.008C33.9833 10.621 33.1602 9.93899 31.1495 9.93899H26.9399V16.0887H25.6465V2.2959H25.6582ZM31.3729 8.83368C33.3836 8.83368 34.4066 7.84596 34.4066 6.1292C34.4066 4.41245 33.6306 3.42472 31.5493 3.42472H26.9634V8.82192H31.3847H31.3729V8.83368Z"
      fill={color}
    />
    <path
      d="M36.6641 11.7145V2.2959H37.9575V11.597C37.9575 14.1486 39.3215 15.1833 41.732 15.1833C44.1425 15.1833 45.4948 14.1368 45.4948 11.597V2.2959H46.7882V11.7028C46.7882 14.9011 44.6717 16.2886 41.6732 16.2886C38.6748 16.2886 36.6641 14.8658 36.6641 11.7028V11.7145Z"
      fill={color}
    />
    <path
      d="M48.2813 2.2959H50.0334L54.7956 14.3249H54.8309L59.4755 2.2959H61.2863V16.0887H60.0282V4.07145H59.9929C59.9929 4.07145 59.6284 5.17676 59.3344 5.94107L55.3365 16.0887H54.1959L50.1627 5.94107C49.8687 5.22379 49.4925 4.07145 49.4925 4.07145H49.4572V16.0887H48.2578V2.2959H48.2813Z"
      fill={color}
    />
    <path
      d="M15.5919 14.6773C13.3343 13.8777 11.7116 11.7141 11.7116 9.17427C11.7116 6.63441 13.3343 4.48259 15.5919 3.67125V2.27197C12.5817 3.11859 10.3711 5.89362 10.3711 9.17427C10.3711 12.4549 12.5817 15.2182 15.5919 16.0766V14.6655V14.6773Z"
      fill="#DF2F26"
    />
    <path
      d="M19.5078 2.2832V3.69424C21.7655 4.49382 23.3764 6.6574 23.3764 9.1855C23.3764 11.7136 21.7655 13.8772 19.5078 14.6768V16.0878C22.518 15.2412 24.7286 12.4662 24.7286 9.1855C24.7286 5.90485 22.518 3.12982 19.5078 2.2832Z"
      fill="#DF2F26"
    />
    <path
      d="M64.0863 1.6900C64.9700 1.6900 65.6863 2.4063 65.6863 3.2900C65.6863 4.1737 64.9700 4.8900 64.0863 4.8900C63.2026 4.8900 62.4863 4.1737 62.4863 3.2900C62.4863 2.4063 63.2026 1.6900 64.0863 1.6900ZM64.0863 2.0100C63.3794 2.0100 62.8063 2.5831 62.8063 3.2900C62.8063 3.9969 63.3794 4.5700 64.0863 4.5700C64.7932 4.5700 65.3663 3.9969 65.3663 3.2900C65.3663 2.5831 64.7932 2.0100 64.0863 2.0100ZM64.1948 3.3299Q64.2505 3.3487 64.3032 3.4105Q64.3559 3.4722 64.4091 3.5802L64.5848 3.9300H64.3988L64.2350 3.6016Q64.1716 3.4730 64.1120 3.4310Q64.0524 3.3890 63.9496 3.3890H63.7609V3.9300H63.5878V2.6500H63.9787Q64.1982 2.6500 64.3062 2.7417Q64.4142 2.8335 64.4142 3.0187Q64.4142 3.1395 64.3581 3.2193Q64.3019 3.2990 64.1948 3.3299ZM63.7609 2.7923V3.2467H63.9787Q64.1039 3.2467 64.1677 3.1888Q64.2316 3.1310 64.2316 3.0187Q64.2316 2.9063 64.1677 2.8493Q64.1039 2.7923 63.9787 2.7923Z"
      fill={color}
    />
  </svg>
);
